<template>
  <div class="main_right">
    <div class="page_info">
      <Breadcrumb class="breadcrumb">
        <BreadcrumbItem>简称查询</BreadcrumbItem>
      </Breadcrumb>
      <div class="searchBox">
        <div></div>
        <div>
          <Input v-model="reqbody.searchKey" icon="ios-search" placeholder="全称" style="width: 200px" @on-click="search" @keyup.13.native="search"/>
          <!--<Button type="ghost" icon="ios-cloud-download-outline" @click="exportDevice" v-if="authList.indexOf('011004') !== -1">导出</Button>-->
        </div>
      </div>

      <Table border height="520" ref="query_short" :columns="columns" :data="tableData"></Table>
      <page :total="total" show-sizer class="table_page" @on-change="changePageNo" @on-page-size-change="changePageSize" show-total></page>
    </div>

    <modal
      v-model="dialog"
      title="请勿恶意修改"
      @on-ok="confirm"
      @on-cancel="cancel">
      <div style="width: 300px;display: block;margin: 20px auto 0;overflow: hidden;">
        <div style="float: left;line-height: 30px;width: 60px;">备注：</div>
        <Input v-model="modifyData.memo" style="width: 240px;float: left;" :maxlength=32 />
      </div>
    </modal>
  </div>
</template>

<script>
import {httpUrl} from '../../api'
import {errorHandler} from '../../util/errorHandler'
import {nSuccess} from '../../util/notice'
import {getAuthStr} from '../../util/bus'

export default {
  name: 'query-short',
  data () {
    return {
      authList: '',
      dialog: false,
      partnerList: [],
      merchantList: [],
      statusList: [{
        code: '1',
        name: '入库'
      }, {
        code: '2',
        name: '出库'
      }, {
        code: '3',
        name: '故障'
      }, {
        code: '4',
        name: '作废'
      }],
      reqbody: {
        partnerId: '',
        status: '',
        searchKey: '',
        pageSize: 10,
        pageNo: 1
      },
      modifyData: {
        id: '',
        memo: ''
      },
      columns: [{
        title: '简称',
        key: 'shortName',
        align: 'center'
      }, {
        title: '全称',
        key: 'fullName',
        align: 'center'
      }, {
        title: '场景',
        key: 'sence',
        align: 'center'
      }, {
        title: '备注',
        key: 'memo',
        align: 'center'
      }, {
        title: '操作',
        key: 'operation',
        width: 80,
        align: 'center',
        render: (h, params) => {
          return h('div', [
            h('Icon', {
              props: {
                type: 'edit'
              },
              style: {
                color: '#2d8cf0',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  this.modifyWarehouse(params.row)
                }
              }
            }),
            h('span', {
              style: {
                color: '#2d8cf0',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  this.modifyWarehouse(params.row)
                }
              }
            }, '修改')
          ])
        }
      }],
      tableData: [],
      total: 0,
      deleteDevId: {},
      batchId: {
        ids: ''
      }
    }
  },
  created () {
    this.authList = getAuthStr()
    this.getPartnerList()
    this.getBusinessList()
    this.getAbbreviationPage()
  },
  methods: {
    // 获取合作伙伴列表
    getPartnerList () {
      this.$axios.post(`${httpUrl.url}/manage/partner/getList`, this.reqbody)
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data
            this.partnerList = list
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    // 获取商户列表
    getBusinessList () {
      this.$axios.post(`${httpUrl.url}/manage/merchant/getList`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data
            this.merchantList = list
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    getAbbreviationPage () {
      this.$axios.post(`${httpUrl.url}/manage/abbreviation/getPage`, this.reqbody)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            let list = data.list
            list.map(v => {
              if (v.status === '1') {
                v.state = '入库'
              } else if (v.status === '2') {
                v.state = '出库'
              } else if (v.status === '3') {
                v.state = '故障'
              } else {
                v.state = '作废'
              }
            })
            if (this.authList.indexOf('011002') !== -1) {
              list.map(v => {
                v.authStatusM = true
              })
            } else {
              list.map(v => {
                v.authStatusM = false
              })
            }
            this.tableData = list
            this.total = data.total
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    updateAbbreviation () {
      this.$axios.post(`${httpUrl.url}/manage/abbreviation/updateById`, this.modifyData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.getAbbreviationPage()
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    changePageNo (m) {
      this.reqbody.pageNo = m
      this.getAbbreviationPage()
    },
    changePageSize (n) {
      this.reqbody.pageSize = n
      this.getAbbreviationPage()
    },
    search () {
      this.reqbody.pageNo = 1
      this.getAbbreviationPage()
    },
    // 导出
    exportDevice () {
      let exportUrl = `${httpUrl.url}/manage/ioRecord/export?searchKey=${this.reqbody.searchKey}&partnerId=${this.reqbody.partnerId}&status=${this.reqbody.status}`
      this.downloadFile('', exportUrl)
    },
    downloadFile (fileName, href) {
      let eleLink = document.createElement('a')
      eleLink.download = fileName
      eleLink.style.display = 'none'
      eleLink.href = href
      eleLink.click()
    },
    modifyWarehouse (row) {
      this.dialog = true
      this.modifyData.id = row.id
      this.modifyData.memo = row.memo
    },
    cancel () {
      this.dialog = false
    },
    confirm () {
      this.dialog = false
      this.updateAbbreviation()
    },
  }
}
</script>

<style scoped>
  .main_right {
    min-width: 780px;
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }
  .searchBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .table_page {
    text-align: right;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/query-short/query-short.vue